<script setup lang="ts">
import { GeneralChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import { ANNOTATOR_TYPES } from '@/composables/charts/influx-charts/ChartIncidentAnnotators'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'

import GenericInfluxChart from '@/composables/charts/GenericInfluxChart.vue'
import { CameraBasedInfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/CameraBasedInfluxLineChartBuilder'
withDefaults(
  defineProps<{
    synchronizationKey?: string
    fixedTimeResolution?: number
    days?: number
  }>(),
  {
    synchronizationKey: undefined,
    fixedTimeResolution: undefined,
    days: 7,
  }
)
</script>

<template>
  <GenericInfluxChart
    :chart-builder="
      new CameraBasedInfluxLineChartBuilder({
        chartType: CHART_TYPES.CAMERA_BASED_LINE,
        measurement: 'speed',
        field: 'speed',
        xAggregation: 'mean',
        timeSetup: GeneralChartTimeSetup.lastNDays(days, synchronizationKey, fixedTimeResolution).serialize(),
        title: $t('charts.titles.speed'),
        subtitle: $t('charts.subtitles.speedGlobal'),
        incidentAnnotators: [{ annotatorType: ANNOTATOR_TYPES.BARNDOC }, { annotatorType: ANNOTATOR_TYPES.SPARSE_DICT_ANOMALY }],
        incidentReducer: { reducerType: 'penState' },
        cameraTagSelector: { tag: 'camera', allowEmptyValues: false, groupByValues: true, useAll: true },
      })
    "
  ></GenericInfluxChart>
</template>

<style scoped></style>
